import axios from 'axios'
import { versionAPI } from '@shared/api/_version'

export default {
  getLocation(url) {
    return axios.get(`${url}`)
  },
  confirmHandshake(url, data) {
    return axios.post(url + '/' + versionAPI + '/api/feedback/', data)
  },
  saveFeedback(url, data) {
    return axios.put(url + '/' + versionAPI + '/api/feedback/', data)
  },
  validateInput(url, data) {
    return axios.post(url + '/' + versionAPI + '/api/validate-email/', data)
  },
}
